import { createApp } from 'vue';
import Filter from '../components/filter/Filter.vue'
import AdvertisementForm from '../components/advertisement/AdvertisementForm.vue'
import CarGallery from '../components/gallery/CarGallery.vue'
import ApiService from '../services/apiService.js'

import store from '../vuex'
import { Tab } from 'bootstrap';

export const AdvertisementIndexView = {

  async init() {
    const filter = document.getElementById('filter-wrapper')
    const searchParams = JSON.parse(filter.dataset.searchParams)
    // Empty when the current page has no resolved @nice_url (e.g. a raw filtered query URL).
    const currentFilter = filter.dataset.currentFilter ? JSON.parse(filter.dataset.currentFilter) : null
    // Cached client-side (see Api::V1::NiceUrlsController) so it's only re-downloaded periodically, not on every page view.
    const { data } = await ApiService.get('nice_urls')
    const niceUrls = data.nice_urls
    const personalNiceUrl = niceUrls.filter(u => u.model_type === 'personal')
    const utilityNiceUrl = niceUrls.filter(u => u.model_type === 'utility')
    // currentFilter belongs to a single model_type (the one the current page was resolved for) – only
    // pass it to the matching tab, the other tab falls back to the niceUrls-based lookup as before.
    const personalCurrentFilter = currentFilter?.model_type === 'personal' ? currentFilter : null
    const utilityCurrentFilter = currentFilter?.model_type === 'utility' ? currentFilter : null

    let ssrInit = true
    let personalFilter = undefined
    let utilityFilter = undefined
    let modelType = undefined
    const buildBaseUrl = (modelType) => { return `/inzerce/${modelType === 'utility' ? 'uzitkova-auta' : 'osobni-auta'}` }

    // Needed to propagate sort parameter when switching tabs.
    const getSortFromUrl = () => {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('sort') || ''
    }

    document.addEventListener('show.bs.tab', function(e) {
      const sort = getSortFromUrl()
      if(e.target.id === 'nav-personal-tab') {
        modelType = 'personal'
        if(personalFilter) {
          personalFilter.initialize({sort})
        } else {
          personalFilter = createApp(Filter, { redirect: false, baseUrl: buildBaseUrl(modelType), modelType: modelType, searchParams, niceUrls: personalNiceUrl, currentFilter: personalCurrentFilter})
            .use(store)
            .mount('#filter-wrapper-personal')
          if(ssrInit) {
            personalFilter.loadFilterOptions()
          } else {
            personalFilter.initialize({sort})
          }
        }
        window.filter = personalFilter
      } else if(e.target.id === 'nav-utility-tab') {
        modelType = 'utility'
        if(utilityFilter) {
          utilityFilter.initialize({sort})
        } else {
          utilityFilter = createApp(Filter, { redirect: false, baseUrl: buildBaseUrl(modelType), modelType: modelType, searchParams, niceUrls: utilityNiceUrl, currentFilter: utilityCurrentFilter})
            .use(store)
            .mount('#filter-wrapper-utility')
          if(ssrInit) {
            utilityFilter.loadFilterOptions()
          } else {
            utilityFilter.initialize({sort})
          }
        }
        window.filter = utilityFilter
      }
    })

    if(searchParams.model_type === 'personal') {
      const tab = new Tab(document.querySelector('#nav-personal-tab'))
      tab.show()
    } else if(searchParams.model_type === 'utility') {
      const tab = new Tab(document.querySelector('#nav-utility-tab'))
      tab.show()
    }
    ssrInit = false
  }

}

export const AdvertisementShowView = {

  init() {
    const el = document.getElementById('car-gallery')
    if (!el) return
    createApp(CarGallery, {
      photos: JSON.parse(el.dataset.photos),
      reserved: el.dataset.reserved === 'true',
      active: el.dataset.active === 'true',
      advertisementId: el.dataset.advertisementId,
      favorited: el.dataset.favorited === 'true',
    }).mount('#car-gallery')
  },

}

export const AdvertisementNewView = {

  init() {
    createApp(AdvertisementForm, { action: 'create' })
      .use(store)
      .mount('#form-advertisement')
  }

}

export const AdvertisementEditView = {

  init() {
    const wrapper = document.getElementById('form-advertisement')
    createApp(AdvertisementForm, { advertisementId: wrapper.dataset.advertisementId, action: 'update' })
        .use(store)
        .mount('#form-advertisement')
  }

}